import { isInView } from './utils';

const scrollCart = {
  prodLine: document.getElementById('jsCartLine'),
  cartLine: document.getElementById('addToCartLine'),
  cartBtn: document.querySelector('.jsInView') as HTMLElement | null,

  init() {
    window.addEventListener('DOMContentLoaded', this.setScroll.bind(this));
    window.addEventListener('scroll', this.setScroll.bind(this));
  },

  setScroll() {
    if (this.cartBtn && isInView(this.cartBtn)) {
      this.cartLine?.classList.add('activeClass');
      this.prodLine?.classList.remove('activeClass');
    } else {
      this.cartLine?.classList.remove('activeClass');
       this.prodLine?.classList.add('activeClass');
    }
  },
};

export default scrollCart;